import type { Invitation } from "../../types/invitation";
import { httpClient } from "./httpClient";

export interface UnsubscribeReminderParams {
    token: string;
    reason: string;
    otherReason?: string;
}

export interface BenefitsEmailParams {
    token: string;
    language?: string;
}

export interface OpenedDashboardParams {
    token: string;
}

export const fetchInvitation = async (token: string): Promise<Invitation> => {
    if (!token) {
        throw new Error("Invitation token is required");
    }

    return httpClient.get<Invitation>(`/rest/invitations/${encodeURIComponent(token)}`, { auth: false });
};

export const fetchInvitationQuery = (token?: string | null) => (): Promise<Invitation> => {
    if (!token) {
        throw new Error("Invitation token is required");
    }
    return fetchInvitation(token);
};

export const sendBenefitsEmail = (params: BenefitsEmailParams): Promise<{ success: boolean }> => {
    return httpClient.post<{ success: boolean }>("/rest/invitations/benefits-email", params, { auth: false });
};

export const unsubscribeReminder = (params: UnsubscribeReminderParams): Promise<{ success: boolean }> => {
    return httpClient.post<{ success: boolean }>("/rest/invitations/unsubscribe", params, { auth: false });
};

export const recordOpenedDashboard = (params: OpenedDashboardParams): Promise<{ success: boolean }> => {
    return httpClient.post<{ success: boolean }>("/rest/invitations/opened-dashboard", params, { auth: false });
};
